import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CustomizerSettingsService } from '../app/components/customizer-settings/customizer-settings.service';
import { ToggleService } from '../app/components/common/header/toggle.service';
import { TitleService } from './core/services/title.service';
import { NetworkStatusService } from './core/services/network/network-status.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MessagingService } from './core/services/firebasepush/messaging.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    @ViewChild('notification', { static: false }) notificationElement!: ElementRef;
    title = 'Tagus - Material Design Angular Admin Dashboard Template';
    isToggled = false;

    isOnline: boolean = true;
    isRetrying: boolean = false;
    private subscription: Subscription = new Subscription();
    showConsole: boolean = environment.showconsole;
    message: any = null;
    showWhatsappMsgPopup: boolean = false;
    msgContent:any;

    constructor(
        public router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private titleService: TitleService,
        private networkStatus: NetworkStatusService,
        private messagingService: MessagingService,
        private renderer: Renderer2
    ) {
        this.isOnline = this.networkStatus.isOnline();
        this.subscription = this.networkStatus.online$.subscribe(
            status => {
                this.isOnline = status;
                if (status) {
                    this.isRetrying = false;
                }
            }
        );

        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }
    async  ngOnInit() {
        this.titleService.resetTitle();
        if(!this.showConsole) {
            // console.log = function () {};
        }

        // this.firebasePushNotification();
        this.listeningToMessages();
        
    }

    toggleRightSidebarTheme() {
        this.themeService.toggleRightSidebarTheme();
    }

    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    async firebasePushNotification() {
        if ('serviceWorker' in navigator) {
                try {
                    // Register service worker
                    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
                    scope: '/'
                    });
                    
                    console.log('✅ Service Worker registered:', registration);
                    
                    // Wait a bit for service worker to activate
                    await navigator.serviceWorker.ready;
                    console.log('✅ Service Worker is ready');
                    
                    // Now request permission
                    await this.messagingService.requestPermission();
                    this.messagingService.receiveMessages();
                    
                } catch (error) {
                    console.error('❌ Service Worker registration failed:', error);
                }
                } else {
                console.error('Service workers are not supported in this browser');
                }

                // Listen for messages
                this.messagingService.currentMessage.subscribe(msg => {
                if (msg) {
                    console.log('📬 Message in component:', msg);
                }
            });
        }

        listeningToMessages() {

            // if (this.notificationElement) {
            //     this.renderer.setStyle(this.notificationElement.nativeElement, 'display', 'none');
            // }
             this.messagingService.currentMessage.subscribe(msg => {
                // msg = {
                //     "from": "576816357859",
                //     "messageId": "fbdf1706-e0c6-4a2f-ad83-a20ebe769d34",
                //     "notification": {
                //         "title": "916290350142",
                //         "body": "You"
                //     },
                //     "data": {
                //         "conversationId": "68e6030135702f6e5a50d004"
                //     }
                // }
                if (msg) {
                    console.log('📬 Message in component:', msg);
                    this.msgContent = msg;
                    this.showNotification();
                }
            });
        }


        showNotification() {
            this.showWhatsappMsgPopup=true;

            if (this.notificationElement) {
            const notification = this.notificationElement.nativeElement;
            this.renderer.setStyle(notification, 'display', 'block');
            this.renderer.setStyle(notification, 'animation', 'slideIn 0.3s ease-out');
            }
        }

        closeNotification() {
            console.log('Sliding out notification');
            this.showWhatsappMsgPopup=false;;
            if (this.notificationElement) {
            const notification = this.notificationElement.nativeElement;
            this.renderer.setStyle(notification, 'animation', 'slideOut 0.3s ease-out');
            
            setTimeout(() => {
                this.renderer.setStyle(notification, 'display', 'none');
            }, 300);
            }
        }
}
